/**
 * Auto-generated service - DO NOT EDIT MANUALLY
 * Generated from: membership.ts
 * Run: pnpm gen
 */

import { API_METHODS } from '../constants/api-methods';
import { getApiPath } from '../path';
import { type RequestOptions, type Transport } from '../transport';

import type {
  AddUserRoleRequest,
  AddUserRoleResponse,
  ChangeUserRoleRequest,
  ChangeUserRoleResponse,
  CheckMyPermissionsRequest,
  CheckMyPermissionsResponse,
  GetMyRolesRequest,
  GetMyRolesResponse,
  ListUserRolesRequest,
  ListUserRolesResponse,
  RemoveUserRoleRequest,
  RemoveUserRoleResponse,
} from '../types/membership';

export const createMembershipService = (transport: Transport) => ({
  async addUserRole(
    request: AddUserRoleRequest,
    options: RequestOptions = {},
  ): Promise<AddUserRoleResponse> {
    const { user_id, ...body } = request;
    const url = getApiPath(API_METHODS.UserRoleService.AddUserRole, { user_id });
    return transport.post<AddUserRoleResponse>(url, body, options);
  },

  async removeUserRole(
    request: RemoveUserRoleRequest,
    options: RequestOptions = {},
  ): Promise<RemoveUserRoleResponse> {
    const { user_id, role_id, ...body } = request;
    const url = getApiPath(API_METHODS.UserRoleService.RemoveUserRole, { user_id, role_id });
    return transport.delete<RemoveUserRoleResponse>(url, { data: body, ...options });
  },

  async listUserRoles(
    request: ListUserRolesRequest,
    options: RequestOptions = {},
  ): Promise<ListUserRolesResponse> {
    const { user_id, ...params } = request;
    const url = getApiPath(API_METHODS.UserRoleService.ListUserRoles, { user_id });
    return transport.get<ListUserRolesResponse>(url, { params, ...options });
  },

  async getMyRoles(
    request: GetMyRolesRequest,
    options: RequestOptions = {},
  ): Promise<GetMyRolesResponse> {
    const url = getApiPath(API_METHODS.UserRoleService.GetMyRoles);
    return transport.get<GetMyRolesResponse>(url, { params: request, ...options });
  },

  async checkMyPermissions(
    request: CheckMyPermissionsRequest,
    options: RequestOptions = {},
  ): Promise<CheckMyPermissionsResponse> {
    const url = getApiPath(API_METHODS.UserRoleService.CheckMyPermissions);
    return transport.post<CheckMyPermissionsResponse>(url, request, options);
  },

  async changeUserRole(
    request: ChangeUserRoleRequest,
    options: RequestOptions = {},
  ): Promise<ChangeUserRoleResponse> {
    const { user_id, ...body } = request;
    const url = getApiPath(API_METHODS.UserRoleService.ChangeUserRole, { user_id });
    return transport.post<ChangeUserRoleResponse>(url, body, options);
  },
});

export type MembershipService = ReturnType<typeof createMembershipService>;
